/**
 * Autosave for the live-preview pane (DAB-875): while the pane is open and the
 * draft is dirty, the editor saves ~1500 ms after the last edit so the pane
 * follows typing without an explicit Save.
 *
 * Only "should an attempt be scheduled at all" is pulled out as pure logic.
 * Sequencing concurrent saves — never overlapping a manual Save, Publish or a
 * previous autosave, and running exactly one follow-up for an edit that lands
 * mid-save — is inherently about timing and in-flight state, so it lives in
 * `useDraftAutosave.js`, which owns the timers.
 *
 * `isDirty` is the only gate this needs. The editor has no field-level
 * validation to fold in (no `isValid`/`required` notion anywhere in
 * FieldInput.jsx, fieldValues.js or ListInput.jsx) — it is the same dirty
 * check the Save button already disables on.
 */

/** Wait this long after the last edit before autosaving. */
export const AUTOSAVE_DELAY_MS = 1500;

/** Schedule an autosave attempt only while the pane is open on a dirty form. */
export const autosaveAction = ({ isOpen, isDirty }) =>
  isOpen && isDirty ? "schedule" : "none";
